var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M120-240v-80h720v80zm0-200v-80h720v80zm0-200v-80h720v80z"
})));
export default SvgMenu;